export const memberSlider = () => {
  $(function () {
    const $body = $("body");
    const $memberSlider = $(".js-member-slider");

    let path;

    if ($body.hasClass("top")) {
      path = "./wp/wp-content/themes/value_frontier";
    } else {
      path = "../../wp/wp-content/themes/value_frontier";
    }

    $memberSlider.slick({
      autoplay: true,
      autoplaySpeed: 3000,

      slidesToShow: 3,
      centerMode: true,
      // centerPadding: "12%",
      centerPadding: "18%",
      infinite: true,
      prevArrow: `<img src="${path}/assets/images/top/img_slider-arrow01.svg" width="105" height="105" loading="lazy" class="slide-arrow prev-arrow">`,

      nextArrow: `<img src="${path}/assets/images/top/img_slider-arrow02.svg" width="105" height="105" loading="lazy" class="slide-arrow next-arrow">`,
      appendArrows: $(".c-member-slider__slider-arrows"),

      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 3,
            centerPadding: "10%",
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            centerPadding: "10%",
          },
        },
      ],

      // responsive: [
      //   {
      //     breakpoint: 768,
      //     settings: {
      //       centerPadding: "5%",
      //     },
      //   },
      //   {
      //     breakpoint: 1025,
      //     settings: {
      //       centerPadding: "8%",
      //     },
      //   },
      //   {
      //     breakpoint: 1200,
      //     settings: {
      //       centerPadding: "10%",
      //     },
      //   },
      //   {
      //     breakpoint: 1400,
      //     settings: {
      //       centerPadding: "50%",
      //     },
      //   },
      // ],
    });

    $(document).ready(function () {
      // ページ読み込み時にアニメーションを動作させる
      sliderMove();

      // スライダーが移動するたびにアニメーションを動作させる
      $memberSlider.on(
        "beforeChange",
        function (event, slick, currentSlide, nextSlide) {
          resetAnimationClasses();
        }
      );

      $memberSlider.on(
        "afterChange",
        function (event, slick, currentSlide, nextSlide) {
          addAnimationClasses();
        }
      );
    });

    function sliderMove() {
      resetAnimationClasses();
      addAnimationClasses();
    }

    function resetAnimationClasses() {
      $('[class*="current_"]').removeClass(function (index, className) {
        return (className.match(/(^|\s)current_next\d+/g) || []).join(" ");
      });
      $('[class*="current_"]').removeClass(function (index, className) {
        return (className.match(/(^|\s)current_prev\d+/g) || []).join(" ");
      });
    }

    function addAnimationClasses() {
      $memberSlider.find(".slick-current").next().addClass("current_next1");
      $memberSlider
        .find(".slick-current")
        .next()
        .next()
        .addClass("current_next2");
      $memberSlider
        .find(".slick-current")
        .next()
        .next()
        .next()
        .addClass("current_next3");
      $memberSlider
        .find(".slick-current")
        .next()
        .next()
        .next()
        .next()
        .addClass("current_next4");

      $memberSlider.find(".slick-current").prev().addClass("current_prev1");
      $memberSlider
        .find(".slick-current")
        .prev()
        .prev()
        .addClass("current_prev2");
      $memberSlider
        .find(".slick-current")
        .prev()
        .prev()
        .prev()
        .addClass("current_prev3");
      $memberSlider
        .find(".slick-current")
        .prev()
        .prev()
        .prev()
        .prev()
        .addClass("current_prev4");
    }
  });
};
